export default class FieldModel {
  constructor(field, value) {
    this.field = field;
    this.value = value;
  }

  toRecord() {
    return { field: this.field, value: this.value };
  }
}
